import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';

const AsyncNavigationalLocalSearch = Load(() => import(/* webpackChunkName: "local-search-navigational" */'./containers/NavigationalLocalSearchContainer'), {}, true);
const AsyncLocalSearch = Load(() => import(/* webpackChunkName: "local-search" */'./containers/LocalSearchContainer'), {}, true);

const LocalGuideRoutes = [
  (
    <NavigationableLayout
      key="local-search"
      path={`${basePath}/locals`}
      component={AsyncLocalSearch}
      showBottomNavigation
      showSearchInNavbar
      subNavbar="localFilters"
    />
  ),
  (
    <NavigationableLayout
      key="navigational-local-search"
      path={`${basePath}/l`}
      component={AsyncNavigationalLocalSearch}
      showBottomNavigation
      showSearchInNavbar
      subNavbar="localFilters"
    />
  ),
];

export default LocalGuideRoutes;
